import rdfJsDatasetModule from '@rdfjs/dataset';

//
rdfJsDatasetModule.dataset;
const localNodeSkolemPrefix = "https://inrupt.com/.well-known/sdk-local-node/";
/**
 * Runtime freezing might be too much overhead;
 * if so, this function allows us to replace it by a function
 * that merely marks its input as Readonly<> for static analysis.
 */
const { freeze } = Object;
function isLocalNodeIri(iri) {
    return (iri.substring(0, localNodeSkolemPrefix.length) === localNodeSkolemPrefix);
}
function getLocalNodeName(localNodeIri) {
    return localNodeIri.substring(localNodeSkolemPrefix.length);
}
function getLocalNodeIri(localNodeName) {
    return `${localNodeSkolemPrefix}${localNodeName}`;
}
function isBlankNodeId(value) {
    return typeof value === "string" && value.substring(0, 2) === "_:";
}
function getBlankNodeValue(blankNodeId) {
    return blankNodeId.substring(2);
}
function getBlankNodeId(blankNode) {
    return `_:${blankNode.value}`;
}

export { freeze, getBlankNodeId, getBlankNodeValue, getLocalNodeIri, getLocalNodeName, isBlankNodeId, isLocalNodeIri, localNodeSkolemPrefix };
